import { useState } from 'react';

const faqs = [
  {
    q: '什么是蘑菇成品人视频？',
    a: '蘑菇成品人视频是指展示蘑菇从菌种培育到成品采收全过程的视频教程资源。本网站精选汇聚了涵盖蘑菇种植全流程、成品展示及人工操作技巧的优质蘑菇成品人视频，帮助用户通过观看视频快速掌握蘑菇种植技术。',
  },
  {
    q: '新手如何开始学习蘑菇种植？',
    a: '对于新手，建议从平菇开始入手，因为它生长速度快、抗逆性强。观看我们的"新手必看：蘑菇种植入门指南"视频教程，了解菌种选择、培养基配制和环境控制等基础知识。',
  },
  {
    q: '蘑菇种植需要什么设备？',
    a: '基础种植需要：灭菌锅（可用家用高压锅替代）、接种箱或超净工作台、温湿度计、喷雾器等。初学者可以从简易设备开始，逐步升级。具体设备清单可参考我们的"智能化菇房建设方案"文章。',
  },
  {
    q: '蘑菇种植周期一般多长？',
    a: '不同品种周期不同。平菇从接种到采收约25-35天，香菇需要60-90天，灵芝则需要90-120天。温度、湿度等环境因素会影响实际生长速度。',
  },
  {
    q: '如何判断蘑菇是否可以采收了？',
    a: '采收时机因品种而异。一般来说，平菇在菌盖展开但未完全平展时采收最佳；香菇在菌盖七八分展开、菌膜刚破裂时采收。详细技巧可参考我们的"蘑菇采收时机判断技巧"文章。',
  },
  {
    q: '网站上的视频都是免费观看的吗？',
    a: '是的，本网站汇聚的所有蘑菇成品人视频资源均为免费观看。我们致力于为广大蘑菇种植爱好者提供最全面的蘑菇种植视频教程，帮助更多人掌握蘑菇培育技术。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 animate-fade-in">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于蘑菇成品人视频的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden animate-fade-in-up"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-60 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}